import { OffersActions, SortType } from '../../../reducers/offers';
import { ReduxDispatchInterface } from '@ecommerce/nest-ssr';
import { ProductUrlParams } from 'modules/product/interfaces/product-url-params.interface';
import prepareActionName from '../../../reducers/helpers/prepare-action-name';
import OfferInterface from 'interfaces/offer.interface';

const updateProductUrlHistory = (productUrlParams: ProductUrlParams, dispatch: ReduxDispatchInterface, items: OfferInterface[]): void => {
    if (productUrlParams.query?.filters?.length) {
        dispatch({
            type: OffersActions.Filter,
            payload: {
                activeFilters: productUrlParams.query.filters.split(','),
                replaceState: false,
                items
            }
        });
    }

    if (productUrlParams.query?.sort) {
        dispatch({
            type: prepareActionName(`OFFERS_SORT_${productUrlParams.query.sort.toUpperCase()}`) as unknown as SortType,
            payload: {
                activeSort: productUrlParams.query.sort,
                replaceState: false,
                items
            }
        });
    }
};

export default updateProductUrlHistory;
